import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Search, X, ArrowRight, Clock, TrendingUp, ExternalLink } from 'lucide-react';
import { track } from '../lib/track';

// ─── Índice de busca interno ─────────────────────────────────────────────────
const SEARCH_INDEX = [
  // Serviços TI
  { id: 'manutencao-preventiva',  title: 'Manutenção Preventiva',          category: 'Serviços', description: 'Revisão sistemática de equipamentos para evitar falhas', href: '#servicos', tags: 'revisao preventiva equipamentos' },
  { id: 'suporte-ti',             title: 'Suporte de TI para Empresas',    category: 'Serviços', description: 'Help desk TI, atendimento remoto e presencial rápido',  href: '#servicos', tags: 'helpdesk remoto presencial empresa' },
  { id: 'manutencao-corretiva',   title: 'Manutenção Corretiva',           category: 'Serviços', description: 'Reparo especializado em computadores e notebooks',       href: '#servicos', tags: 'reparo conserto defeito' },
  { id: 'formatacao',             title: 'Formatação de Computador',       category: 'Serviços', description: 'Formatação e instalação do Windows com todos os drivers', href: '#servicos', tags: 'windows instalacao formatacao driver' },
  { id: 'upgrade',                title: 'Instalação e Upgrade de Hardware',category: 'Serviços', description: 'SSD, RAM, placa de vídeo e outros upgrades',            href: '#servicos', tags: 'ssd hd memoria ram upgrade hardware' },
  { id: 'terceirizacao-ti',       title: 'Terceirização de TI',            category: 'Serviços', description: 'TI terceirizada completa para empresas',                 href: '#servicos', tags: 'terceirizacao outsourcing empresa' },
  { id: 'redes',                  title: 'Redes e Infraestrutura',         category: 'Serviços', description: 'Cabeamento estruturado, Wi-Fi corporativo e firewall',   href: '#servicos', tags: 'rede wifi cabeamento firewall infraestrutura' },
  { id: 'consultoria',            title: 'Consultoria de TI',              category: 'Serviços', description: 'Planejamento estratégico e redução de custos com TI',    href: '#servicos', tags: 'consultoria planejamento estrategico' },
  // Intelbras
  { id: 'cameras-intelbras',      title: 'Câmeras de Segurança CFTV',     category: 'Intelbras', description: 'Câmeras Intelbras dome e bullet Full HD com acesso remoto', href: '#intelbras', tags: 'cameras cftv seguranca vigilancia intelbras' },
  { id: 'alarmes-intelbras',      title: 'Sistemas de Alarme Intelbras',  category: 'Intelbras', description: 'Centrais de alarme com sensores e monitoramento 24h',     href: '#intelbras', tags: 'alarme sensor monitoramento intelbras' },
  { id: 'wifi-intelbras',         title: 'Redes Wi-Fi Intelbras',         category: 'Intelbras', description: 'Access points e roteadores Intelbras para empresas',       href: '#intelbras', tags: 'wifi access point roteador intelbras' },
  // Daten
  { id: 'loja-daten',             title: 'Loja Daten',                    category: 'Loja', description: 'Notebooks, desktops, mini PCs e all in one Daten com assistência autorizada', href: '/loja-daten', tags: 'loja daten comprar notebook desktop mini pc all in one' },
  { id: 'navegamer',              title: 'Navegamer — PC Gamer',          category: 'Loja', description: 'PCs gamer, notebooks NAVE RTX e periféricos SteelSeries',                     href: '/navegamer',  tags: 'navegamer nave pc gamer notebook gamer rtx steelseries teclado mouse' },
  { id: 'daten-notebooks',        title: 'Notebooks Daten',               category: 'Daten', description: 'Notebooks homologados para licitações públicas com garantia Daten', href: '/daten', tags: 'notebook licitacao daten governo' },
  { id: 'daten-desktops',         title: 'Desktops Daten',                category: 'Daten', description: 'Computadores Daten para empresas e setor público',               href: '/daten', tags: 'desktop computador daten empresa' },
  { id: 'daten-servidores',       title: 'Servidores Daten',              category: 'Daten', description: 'Servidores Daten para ambientes corporativos e virtualizados',    href: '/daten', tags: 'servidor daten corporativo virtualização' },
  { id: 'daten-monitores',        title: 'Monitores Daten',               category: 'Daten', description: 'Monitores Full HD e 4K Daten para empresas e home office',       href: '/daten', tags: 'monitor tela display daten' },
  { id: 'daten-revenda',          title: 'Revenda Autorizada Daten',      category: 'Daten', description: 'Fernando Tech é revenda autorizada Daten em Ribeirão Preto',     href: '/daten', tags: 'revenda autorizada daten ribeirão preto' },
  // Assistência Técnica
  { id: 'assistencia-notebook',   title: 'Assistência Técnica Notebook',  category: 'Assistência', description: 'Reparo especializado em notebooks: tela, teclado, bateria, placa-mãe', href: '/assistencia-tecnica', tags: 'notebook reparo tela teclado bateria placa' },
  { id: 'assistencia-desktop',    title: 'Manutenção de Desktop',         category: 'Assistência', description: 'Manutenção preventiva e corretiva em computadores desktop',            href: '/assistencia-tecnica', tags: 'desktop computador manutencao preventiva' },
  { id: 'assistencia-monitor',    title: 'Reparo de Monitor',             category: 'Assistência', description: 'Conserto de monitores com defeito de imagem, tela piscando ou sem sinal', href: '/assistencia-tecnica', tags: 'monitor tela reparo conserto defeito' },
  { id: 'assistencia-nobreak',    title: 'Manutenção de No-break / UPS',  category: 'Assistência', description: 'Reparo e troca de bateria em no-breaks e estabilizadores',              href: '/assistencia-tecnica', tags: 'nobreak ups bateria estabilizador reparo' },
  // Produtos
  { id: 'shoficina',              title: 'SHOficina ERP',                 category: 'Produtos', description: 'Sistema de gestão para oficinas mecânicas — OS, estoque e nota fiscal', href: '#shoficina-erp',  tags: 'shoficina erp oficina gestao sistema' },
  { id: 'shoficina-comprar',      title: 'Comprar SHOficina',             category: 'Produtos', description: 'Adquirir licença anual do SHOficina a partir de R$ 268,90',             href: '/comprar',         tags: 'comprar licença shoficina preco' },
  { id: 'nfe',                    title: 'Emissor de NF-e (Mod. 55)',     category: 'Produtos', description: 'Emissão de Nota Fiscal eletrônica modelo 55',                           href: '/comprar',         tags: 'nota fiscal nfe modelo 55' },
  { id: 'nfce',                   title: 'Emissor de NFC-e (Mod. 65)',    category: 'Produtos', description: 'Cupom Fiscal Eletrônico para venda no balcão',                          href: '/comprar',         tags: 'nfce cupom fiscal balcão' },
  { id: 'nfse',                   title: 'Emissor de NFS-e',              category: 'Produtos', description: 'Nota Fiscal de Serviços eletrônica para oficinas mecânicas',            href: '/comprar',         tags: 'nfse nota servicos' },
  { id: 'bling-erp',              title: 'Bling ERP',                     category: 'Produtos', description: 'Sistema ERP completo para gestão empresarial',                         href: '/bling',           tags: 'bling erp gestao empresa sistema' },
  // Soluções
  { id: 'hospedagem',             title: 'Hospedagem Empresarial',        category: 'Soluções', description: 'Hospedagem de sites com alta performance, SSL e suporte',              href: '#hospedagem',      tags: 'hospedagem site ssl performance' },
  { id: 'sites-ia',               title: 'Sites com Inteligência Artificial', category: 'Soluções', description: 'Criação de sites profissionais com IA e design moderno',         href: '/sites',           tags: 'site ia inteligencia artificial design' },
  { id: 'suporte-remoto',         title: 'Suporte Remoto',                category: 'Soluções', description: 'Acesso remoto seguro e rápido para resolver problemas',                href: '#suporte-remoto',  tags: 'suporte remoto acesso rapido' },
  // Empresa
  { id: 'quem-somos',             title: 'Quem Somos',                    category: 'Empresa', description: 'Fernando Tech desde 2008 — empresa de TI em Ribeirão Preto',           href: '#quem-somos',      tags: 'sobre empresa historia ribeirão preto 2008' },
  { id: 'clientes',               title: 'Clientes VIP',                  category: 'Empresa', description: 'Veja todas as 14 empresas parceiras da Fernando Tech em Ribeirão Preto', href: '/clientes-vip',    tags: 'clientes parceiros empresas ribeirão preto vip' },
  { id: 'contato',                title: 'Contato',                       category: 'Empresa', description: '(16) 99137-8312 | contato@fernandotech.com.br',                        href: '#contato',         tags: 'fone telefone email contato whatsapp' },
];

// ─── Config visual ────────────────────────────────────────────────────────────
const CATEGORY_COLOR = {
  'Serviços':    { bg: 'bg-cyan-900/60',    text: 'text-cyan-300',    border: 'border-cyan-700/60',    dot: 'bg-cyan-400'    },
  'Intelbras':   { bg: 'bg-blue-900/60',    text: 'text-blue-300',    border: 'border-blue-700/60',    dot: 'bg-blue-400'    },
  'Daten':       { bg: 'bg-indigo-900/60',  text: 'text-indigo-300',  border: 'border-indigo-700/60',  dot: 'bg-indigo-400'  },
  'Assistência': { bg: 'bg-violet-900/60',  text: 'text-violet-300',  border: 'border-violet-700/60',  dot: 'bg-violet-400'  },
  'Produtos':    { bg: 'bg-emerald-900/60', text: 'text-emerald-300', border: 'border-emerald-700/60', dot: 'bg-emerald-400' },
  'Soluções':    { bg: 'bg-amber-900/60',   text: 'text-amber-300',   border: 'border-amber-700/60',   dot: 'bg-amber-400'   },
  'Empresa':     { bg: 'bg-slate-800/60',   text: 'text-slate-300',   border: 'border-slate-600/60',   dot: 'bg-slate-400'   },
};

const TRENDING = [
  'Assistência Técnica', 'Notebook reparo', 'Câmeras segurança',
  'SHOficina ERP', 'Daten notebook', 'Suporte TI',
  'No-break', 'Hospedagem', 'Wi-Fi Intelbras', 'Nota fiscal',
];

// ─── Normaliza texto para comparação ─────────────────────────────────────────
const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// ─── Destaca query no texto ───────────────────────────────────────────────────
const Highlight = ({ text, query }) => {
  if (!query) return <>{text}</>;
  const nq = norm(query);
  const nt = norm(text);
  const idx = nt.indexOf(nq);
  if (idx === -1) return <>{text}</>;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="bg-cyan-400/30 text-cyan-200 rounded-sm px-0.5">{text.slice(idx, idx + nq.length)}</mark>
      {text.slice(idx + nq.length)}
    </>
  );
};

// ─── Pontuação de relevância ──────────────────────────────────────────────────
const score = (item, q) => {
  const nt = norm(item.title);
  const nd = norm(item.description);
  const nk = norm(item.tags || '');
  if (nt.startsWith(q)) return 100;
  if (nt.includes(q))    return 80;
  if (nk.includes(q))    return 60;
  if (nd.includes(q))    return 40;
  return 0;
};

// ─── Componente principal ─────────────────────────────────────────────────────
const SearchModal = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const inputRef = useRef(null);

  const navigate = useCallback((href) => {
    // Analytics: track internal search clicks
    if (window.dataLayer) window.dataLayer.push({ event: 'site_search_click', search_term: query, result_href: href });
    if (window.gtag) window.gtag('event', 'select_content', { content_type: 'search_result', content_id: href, search_term: query });
    if (query.trim()) track('search', { term: query.trim() });
    onClose();
    setQuery('');
    setTimeout(() => {
      if (href.startsWith('/')) {
        window.location.href = href;
      } else {
        const el = document.querySelector(href);
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    }, 150);
  }, [onClose, query]);

  const openGoogle = useCallback((q) => {
    // Analytics: track Google fallback searches
    if (window.dataLayer) window.dataLayer.push({ event: 'site_search_google_fallback', search_term: q });
    if (window.gtag) window.gtag('event', 'search', { search_term: q, search_type: 'google_fallback' });
    if (q && q.trim()) track('search', { term: q.trim() });
    const url = `https://www.google.com/search?q=Fernando+Tech+${encodeURIComponent(q)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (!query.trim()) { setResults([]); return; }
    const q = norm(query);
    const filtered = SEARCH_INDEX
      .map(item => ({ ...item, _score: score(item, q) }))
      .filter(item => item._score > 0)
      .sort((a, b) => b._score - a._score);
    setResults(filtered);
    setSelectedIndex(0);
  }, [query]);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 80);
      setQuery('');
      setResults([]);
      setSelectedIndex(0);
    }
  }, [isOpen]);

  // Total de itens navegáveis: resultados internos + 1 (Google)
  const totalItems = results.length + (query.trim() ? 1 : 0);

  useEffect(() => {
    const handleKey = (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') { onClose(); return; }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setSelectedIndex(i => Math.min(i + 1, totalItems - 1));
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setSelectedIndex(i => Math.max(i - 1, 0));
      }
      if (e.key === 'Enter') {
        if (selectedIndex < results.length && results[selectedIndex]) {
          navigate(results[selectedIndex].href);
        } else if (selectedIndex === results.length && query.trim()) {
          openGoogle(query);
        }
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, results, selectedIndex, totalItems, navigate, openGoogle, query, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[300] flex items-start justify-center px-4"
      style={{ paddingTop: 'clamp(60px, 8vh, 120px)' }}
      data-testid="search-modal"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/65 backdrop-blur-md" onClick={onClose} />

      {/* Container */}
      <div
        className="relative w-full max-w-3xl"
        style={{ animation: 'searchSlideDown 0.18s cubic-bezier(0.34,1.2,0.64,1) both' }}
      >
        <style>{`
          @keyframes searchSlideDown {
            from { opacity: 0; transform: translateY(-12px) scale(0.98); }
            to   { opacity: 1; transform: translateY(0)    scale(1);    }
          }
          .search-results-scroll::-webkit-scrollbar { width: 4px; }
          .search-results-scroll::-webkit-scrollbar-track { background: transparent; }
          .search-results-scroll::-webkit-scrollbar-thumb { background: #334155; border-radius: 2px; }
        `}</style>

        {/* ── Barra de pesquisa ── */}
        <div className="relative flex items-center bg-[#1e2535] border-2 border-slate-600/80 hover:border-slate-500 focus-within:border-cyan-500/70 rounded-full shadow-2xl shadow-black/50 transition-all duration-200 px-5 py-3.5 gap-4">
          <Search className="w-5 h-5 text-slate-400 flex-shrink-0" />
          <input
            ref={inputRef}
            type="text"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Pesquisar serviços, produtos, soluções..."
            className="flex-1 bg-transparent text-white placeholder-slate-500 outline-none text-lg leading-tight"
            data-testid="search-input"
          />
          {query ? (
            <button
              onClick={() => { setQuery(''); inputRef.current?.focus(); }}
              className="text-slate-500 hover:text-white transition-colors p-1 rounded-full hover:bg-slate-700"
              aria-label="Limpar"
            >
              <X className="w-4 h-4" />
            </button>
          ) : (
            <div className="hidden sm:flex items-center gap-1 text-slate-600">
              <kbd className="px-1.5 py-0.5 bg-slate-800 border border-slate-700 rounded text-[11px] font-mono">Ctrl</kbd>
              <span className="text-xs">K</span>
            </div>
          )}
        </div>

        {/* ── Painel de resultados ── */}
        <div className="mt-2 bg-[#1a2133] border border-slate-700/60 rounded-2xl shadow-2xl shadow-black/60 overflow-hidden">

          {/* ── Sem resultados internos ── */}
          {query && results.length === 0 && (
            <div className="py-8 text-center px-6">
              <Search className="w-9 h-9 mx-auto mb-3 text-slate-700" />
              <p className="text-slate-400 text-sm mb-1">
                Nenhum resultado para <span className="text-white font-semibold">"{query}"</span> no site
              </p>
              <p className="text-slate-600 text-xs mb-5">Tente: câmeras, SHOficina, notebook, hospedagem</p>
              {/* Botão Google destacado */}
              <button
                onClick={() => openGoogle(query)}
                className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-semibold rounded-full shadow-lg shadow-cyan-500/20 transition-all text-sm"
                data-testid="search-google-btn-empty"
              >
                <ExternalLink className="w-4 h-4" />
                Buscar "{query}" no Google
              </button>
            </div>
          )}

          {/* ── Resultados internos ── */}
          {results.length > 0 && (
            <>
              <ul className="search-results-scroll max-h-[50vh] overflow-y-auto divide-y divide-slate-800/50 py-1">
                {results.map((item, i) => {
                  const cc = CATEGORY_COLOR[item.category] || CATEGORY_COLOR['Empresa'];
                  return (
                    <li key={item.id}>
                      <button
                        onClick={() => navigate(item.href)}
                        onMouseEnter={() => setSelectedIndex(i)}
                        className={`w-full flex items-center gap-3.5 px-4 py-3 text-left transition-colors ${
                          i === selectedIndex ? 'bg-slate-700/50' : 'hover:bg-slate-800/50'
                        }`}
                        data-testid={`search-result-${item.id}`}
                      >
                        {/* Dot indicator */}
                        <span className={`w-2 h-2 rounded-full flex-shrink-0 ${cc.dot}`} />

                        <div className="flex-1 min-w-0">
                          <p className="text-white text-sm font-medium truncate">
                            <Highlight text={item.title} query={query} />
                          </p>
                          <p className="text-slate-500 text-xs mt-0.5 truncate">
                            <Highlight text={item.description} query={query} />
                          </p>
                        </div>

                        {/* Category pill */}
                        <span className={`hidden sm:inline-flex text-[10px] font-semibold px-2 py-0.5 rounded-full border flex-shrink-0 ${cc.bg} ${cc.text} ${cc.border}`}>
                          {item.category}
                        </span>

                        <ArrowRight className={`w-3.5 h-3.5 flex-shrink-0 transition-colors ${
                          i === selectedIndex ? 'text-cyan-400' : 'text-slate-700'
                        }`} />
                      </button>
                    </li>
                  );
                })}
              </ul>

              {/* ── Opção A: Fallback Google sempre visível ── */}
              <div className="border-t border-slate-700/50 px-4 py-2.5">
                <button
                  onClick={() => openGoogle(query)}
                  onMouseEnter={() => setSelectedIndex(results.length)}
                  className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl text-left transition-all ${
                    selectedIndex === results.length
                      ? 'bg-slate-700/50'
                      : 'hover:bg-slate-800/50'
                  }`}
                  data-testid="search-google-btn"
                >
                  <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-cyan-500">
                    <ExternalLink className="w-3.5 h-3.5 text-white" />
                  </div>
                  <span className="flex-1 text-slate-400 text-xs">
                    Buscar <span className="text-cyan-300 font-medium">"{query}"</span> no Google
                  </span>
                  <span className="text-[10px] text-slate-600 bg-slate-800 border border-slate-700 rounded px-1.5 py-0.5 font-mono hidden sm:block">
                    nova aba
                  </span>
                </button>
              </div>
            </>
          )}

          {/* ── Estado vazio: trending + acesso rápido ── */}
          {!query && (
            <div className="px-5 pt-5 pb-4">

              {/* Trending */}
              <div className="flex items-center gap-2 mb-3">
                <TrendingUp className="w-3.5 h-3.5 text-cyan-500" />
                <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Mais buscados</span>
              </div>
              <div className="flex flex-wrap gap-2 mb-5">
                {TRENDING.map(term => (
                  <button
                    key={term}
                    onClick={() => setQuery(term)}
                    className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-slate-800 border border-slate-700 hover:border-cyan-500/60 hover:bg-slate-700 text-slate-300 hover:text-white text-xs font-medium transition-all"
                    data-testid={`search-trending-${term.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <Search className="w-3 h-3 text-slate-500" />
                    {term}
                  </button>
                ))}
              </div>

              {/* Acesso rápido */}
              <div className="border-t border-slate-800 pt-4">
                <div className="flex items-center gap-2 mb-3">
                  <Clock className="w-3.5 h-3.5 text-cyan-500" />
                  <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Acesso rápido</span>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
                  {[
                    { title: 'Comprar SHOficina ERP',    href: '/comprar',             icon: '📦' },
                    { title: 'Câmeras Intelbras',         href: '#intelbras',           icon: '📷' },
                    { title: 'Assistência Técnica',       href: '#assistencia-tecnica', icon: '🔧' },
                    { title: 'Falar com Especialista',    href: '#contato',             icon: '💬' },
                  ].map(item => (
                    <button
                      key={item.title}
                      onClick={() => navigate(item.href)}
                      className="flex items-center gap-3 px-4 py-2.5 bg-slate-800/50 hover:bg-slate-700/60 border border-slate-700/50 hover:border-cyan-500/30 rounded-xl text-sm text-left transition-all group"
                      data-testid={`quick-link-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      <span>{item.icon}</span>
                      <span className="flex-1 text-slate-300 group-hover:text-white transition-colors">{item.title}</span>
                      <ArrowRight className="w-3.5 h-3.5 text-slate-600 group-hover:text-cyan-400 transition-colors" />
                    </button>
                  ))}
                </div>
              </div>

              {/* Rodapé */}
              <div className="mt-4 pt-3 border-t border-slate-800/60 flex items-center justify-between text-slate-600 text-[11px]">
                <span>↑↓ navegar · Enter abrir · Esc fechar</span>
                <span>Fernando Tech © {new Date().getFullYear()}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchModal;
